import { FolderUpIcon } from 'components/Icons';

import { registerTaskOption } from '../options';

import { CreateSampleProjectModal } from './CreateModal';
import { canCreateSampleProject } from './utils';

export default registerTaskOption({
  Icon: FolderUpIcon,

  getLabel: (t) => t('create-project'),

  modal: 'CREATE_SAMPLE_PROJECT',
  overlay: CreateSampleProjectModal,

  shortcutKey: 'C',

  useOption: ({ task, openModal, loggedUser, project }) => {
    const canCreate = canCreateSampleProject({
      project,
      user: loggedUser,
      task,
    });

    return {
      isEnabled: canCreate,
      action: () => openModal('CREATE_SAMPLE_PROJECT'),
    };
  },
});
